












































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import ajax from "../../lib/ajax";
class PagemembershipTradeRequest extends PageRequest {
  membershipId: number;
  tradeType: number | null = null;
}

@Component({
  components: {},
})
export default class membershipTrades extends AbpBase {
  //请求过滤参数
  pagerequest: PagemembershipTradeRequest = new PagemembershipTradeRequest();
  detailShow: boolean = false;
  membershipList: Array<any> = [];
  tradeTypeList: Array<any> = [
    {
      label: "卖出",
      value: 0,
    },
    {
      label: "买入",
      value: 1,
    },
  ];
  /**
   * @description:获取所有label和value
   */
  async getAllLabelAndValue() {
    var res = await ajax.get(
      "/api/services/app/Membership/GetAllLabelAndValue"
    );
    this.membershipList = res.data.result;
  }
  get list() {
    return this.$store.state.membershipTrade.list;
  }
  get loading() {
    return this.$store.state.membershipTrade.loading;
  }

  pageChange(page: number) {
    this.$store.commit("membershipTrade/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("membershipTrade/setPageSize", pagesize);
    this.getpage();
  }
  search() {
    this.$store.commit("membershipTrade/setCurrentPage", 1);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "membershipTrade/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.membershipTrade.pageSize;
  }
  get totalCount() {
    return this.$store.state.membershipTrade.totalCount;
  }
  get currentPage() {
    return this.$store.state.membershipTrade.currentPage;
  }
  columns = [
    {
      title: "联系人",
      key: "linkMan",
    },
    {
      title: "联系电话",
      key: "phoneNumber",
    },

    {
      title: "价格",
      key: "price",
    },
    {
      title: "类型",
      key: "tradeType",
      render: (h: any, params: any) => {
        return h("span", params.row.tradeType == 0 ? "卖出" : "买入");
      },
    },
    {
      title: "类别",
      key: "category",
    },
    {
      title: "球场名称",
      key: "courtName",
    },
    {
      title: this.L("CreationTime"),
      key: "creationTime",
      render: (h: any, params: any) => {
        return h(
          "span",
          new Date(params.row.creationTime).toLocaleDateString()
        );
      },
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 200,
      align: "center",
      slot: "action",
      render: (h, params) => {
        const hasDeletePermission = this.hasPermission(
          "Pages.Membership.Delete"
        );
        const buttons = [];
        buttons.push(
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: "提示",
                    content: "确定要转入到需求记录吗？",
                    okText: "是",
                    cancelText: "否",
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "membershipTrade/toMembershipDemand",
                        data: params.row.id,
                      });
                      this.$Message.success("转入成功");
                      await this.getpage();
                    },
                  });
                },
              },
            },
            "转入"
          )
        );
        if (hasDeletePermission) {
          buttons.push(
            h(
              "Button",
              {
                props: {
                  type: "error",
                  size: "small",
                },
                style: {
                  marginRight: "5px",
                },
                on: {
                  click: async () => {
                    this.$Modal.confirm({
                      title: "提示",
                      content: "确定要删除该记录吗？",
                      okText: "是",
                      cancelText: "否",
                      onOk: async () => {
                        await this.$store.dispatch({
                          type: "membershipTrade/delete",
                          data: params.row,
                        });
                        await this.getpage();
                      },
                    });
                  },
                },
              },
              "删除"
            )
          );
        }
        return h("div", buttons);
      },
    },
  ];
  async created() {
    this.getAllLabelAndValue();
    this.getpage();
  }
}
